import './toggle.scss';
import type { ToggleProps } from "./Toggle.interface.ts";

export function Toggle(props: ToggleProps) {
  function handleState() {
    return props.toggleState ? props.setToggleState(false) : props.setToggleState(true);
  }

  const sizeMap = {
    small: { width: "32px", height: "20px", checkSize: "14px" },
    medium: { width: "48px", height: "24px", checkSize: "18px" },
    large: { width: "60px", height: "31px", checkSize: "24px" }
  };

  const size = sizeMap[props.size || "large"];

  return (
    <div
      className="toggle-wrapper"
      style={{
        ...props?.style,
        "--toggle-width": size.width,
        "--toggle-height": size.height,
        "--check-size": size.checkSize
      } as React.CSSProperties}
    >
      <div className={["toggle checkcross", props.disabled ? "disabled" : "", props.className].join(" ")}>
        <input
          checked={props.toggleState}
          id={props.id}
          aria-label={props.id}
          className={"toggle-input"}
          type="checkbox"
          onChange={handleState}
          disabled={props.disabled}
        />
        <label className="toggle-item" htmlFor={props.id} aria-label={props.id}>
          <div className={"check"}></div>
        </label>
      </div>
    </div>
  );
}
